import React from "react";
import Header from "@/components/landing/Header";
import ForrasKodHighlight from "@/components/landing/ForrasKodHighlight";
import Hero from "@/components/landing/Hero";
import BeneathSurfaceSection from "@/components/landing/BeneathSurfaceSection";
import MasqueradeSection from "@/components/landing/MasqueradeSection";
import QuoteSection from "@/components/landing/QuoteSection";
import NextPageCTA from "@/components/landing/NextPageCTA";
import NewsletterSignup from "@/components/landing/NewsletterSignup";
import PageFooter from "@/components/landing/PageFooter";

export default function InnerJourney() {
  return (
    <main className="bg-warm text-graphite min-h-screen">
      <Header />
      <ForrasKodHighlight />
      <Hero />
      <BeneathSurfaceSection />
      <MasqueradeSection />
      <QuoteSection />
      <NextPageCTA testId="next-page-cta-inner" />
      <NewsletterSignup source="homepage" />
      <PageFooter />
    </main>
  );
}
